import { Button } from 'antd'
import { toNumber } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { AuctionMemberPageStatus } from '../../../enums/AuctionMemberPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { BidRecordListButtonProps } from './interface'

export const BidRecordListButton = ({ record }: BidRecordListButtonProps) => {
  const { setCurrentAuction, toggleBidRecordListModalVisible } =
    useAuctionListStore(state =>
      pick(state, ['setCurrentAuction', 'toggleBidRecordListModalVisible'])
    )

  const handleClick = () => {
    setCurrentAuction(record)
    toggleBidRecordListModalVisible(true)
  }

  const status = toNumber(record.status ?? AuctionMemberPageStatus.WAIT_AUDIT)

  return status > AuctionMemberPageStatus.BIDDING ? (
    <Button type='link' onClick={handleClick}>
      出价记录
    </Button>
  ) : null
}
